import {IFormField} from "../../../../../models/forms/form-field.interface";
import {
    DegreeOfKinshipTypeEnum
} from "../../../../../services/booking/models/pso/agreements/families/pso-family-agreement.view-model.interface";
import React from "react";
import {useServices} from "../../../../../hooks/use-services.hook";
import {
    StandardDropDownListItemModel
} from "../../../../forms/standard-drop-down/list-view/models/item/standard-drop-down-list-item.model";
import {StandardDropDownComponent} from "../../../../forms/standard-drop-down/standard-drop-down.component";
import {observer} from "mobx-react";
import {FullGridLineBox} from "../../common/boxes/pso-agreement.boxes";

interface DegreeOfKinshipTypeDropDownComponentProps {
    field: IFormField<DegreeOfKinshipTypeEnum>;
    hideLabel?: boolean;
}
export const DegreeOfKinshipTypeDropDownComponent: React.FC<DegreeOfKinshipTypeDropDownComponentProps> = observer((props) => {
    const services = useServices();
    const items = [
        new StandardDropDownListItemModel(DegreeOfKinshipTypeEnum.FirstDegree, services.language.translate('First Degree relative')),
        new StandardDropDownListItemModel(DegreeOfKinshipTypeEnum.SecondDegree, services.language.translate('Second Degree relative')),
        new StandardDropDownListItemModel(DegreeOfKinshipTypeEnum.ThirdDegree, services.language.translate('Third Degree relative')),
        new StandardDropDownListItemModel(DegreeOfKinshipTypeEnum.BeneficiaryOfExtraordinaryLeaveAndPermit, services.language.translate('Beneficiary of extraordinary leave and permits pursuant to Law 104/92 to assist the resident in Sardinia')),
        new StandardDropDownListItemModel(DegreeOfKinshipTypeEnum.LegalGuardian, services.language.translate('Legal guardian of the resident in Sardinia')),
    ];

    return (
        <FullGridLineBox>
            <StandardDropDownComponent field={props.field} items={items} hideLabel={props.hideLabel}/>
        </FullGridLineBox>
    )
})